const state= {

};

const getters = {

};

const actions = {
    import({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.file);
            formData.append('contract_id',params.contract_id);
            global.axios.post(`api/asset-management/import`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve( response );
                })
                .catch(error =>{
                    reject( error )
                } );
        });
    },
    importBackDateJob({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('import',params.file);
            formData.append('contract_id',params.contract_id);
            global.axios.post(`api/asset-management/import-back-date-job`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve( response );
                })
                .catch(error =>{
                    reject( error )
                } );
        });
    },
    // Import Schduled Jobs
    async importSchduledJobs({commit},params){
        return new Promise (( resolve, reject ) => {
            let formData = new FormData();
            formData.append('file_import',params.file_import);
            formData.append('client_contract_id',params.client_contract_id);
            formData.append('maintenance_id',params.maintenance_id);
            global.axios.post(`/api/equipment/import-generate-jobs`,formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    resolve( response );
                })
                .catch(error =>{
                    reject( error )
                } );
        });
    },
};

const mutations = {

};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
